import { Table } from "@aws-amplify/ui-react";
import React from "react";
import { TopPositionsTableHeader } from "./TopPositionsTable.Header";
import { getTopPositionsTableHeadData } from "../../generator";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "@src/store/app_manager/selector";
import { TopPositionsTableBody } from "./TopPositionsTable.Body";
import { DownloadExcel } from "@src/pages/Analytics/components/DownloadExcel";
import { PopularProductModel } from "../../domain/models/PopularProductModel";
import { Box } from "@mui/material";

interface TopPositionsTableBody {
  tableBodyData: PopularProductModel;
  downloadLink?: string;
  onSort: (field: string) => void;
}

export const TopPositionsTable: React.FC<TopPositionsTableBody> = (props) => {
  const language = useSelector(selectCurrentLanguage);
  const tableHeadData = getTopPositionsTableHeadData(language);

  const onExportPressed = () => {};

  const onSort = (field: string) => {
    props.onSort(field);
  };

  return (
    <>
      {props.tableBodyData.products.length === 0 && <Box />}
      {props.tableBodyData.products.length !== 0 && (
        <Table>
          <TopPositionsTableHeader data={tableHeadData} onSort={onSort} />
          <TopPositionsTableBody data={props.tableBodyData.products} />
        </Table>
      )}
      {props.downloadLink != null && (
        <DownloadExcel
          onDownloadPressed={onExportPressed}
          file={props.downloadLink}
        />
      )}
    </>
  );
};